<div class="container-fluid">
  <div class="d-flex flex-column flex-sm-row">
    <mat-form-field>
      <mat-icon matPrefix color="primary">search</mat-icon>
      <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Rechercher" />
    </mat-form-field>
    <mat-slide-toggle (change)="toggleDisplayColumns()" [checked]="displayFullColumns" class="m-3">Afficher toutes
      colonnes</mat-slide-toggle>
    <span class="spacer"></span>
    <button mat-mini-fab appTooltip="Ajouter un partenaire" class="ml-auto m-3 white" color="primary" (click)="add()">
      <mat-icon aria-label="Ajouter un partenaire">add</mat-icon>
    </button>
  </div>
  <div id="compagnieGroup" [class]="tableClass">
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Nom</th>
        <td mat-cell *matCellDef="let row" class="main">{{ row.name }}</td>
      </ng-container>
      <ng-container matColumnDef="services">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Services</th>
        <td mat-cell *matCellDef="let row">{{ row.services | commaStringArray }}</td>
      </ng-container>
      <ng-container matColumnDef="summary">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Résumé</th>
        <td mat-cell *matCellDef="let row">{{ row.company.summary }}</td>
      </ng-container>
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
        <td mat-cell *matCellDef="let row">{{ row.company.description }}</td>
      </ng-container>
      <ng-container matColumnDef="address">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Adresse</th>
        <td mat-cell *matCellDef="let row">{{ row.company.address | fullAddress }}</td>
      </ng-container>
      <ng-container matColumnDef="city">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Ville</th>
        <td mat-cell *matCellDef="let row">{{ row.city }}</td>
      </ng-container>
      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
        <td mat-cell *matCellDef="let row" class="mobile-inline mobile-separator">{{ row.email }}</td>
      </ng-container>
      <ng-container matColumnDef="phoneNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Téléphone</th>
        <td mat-cell *matCellDef="let row">{{ row.company.phoneNumber }}</td>
      </ng-container>
      <ng-container matColumnDef="webSite">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Site web</th>
        <td mat-cell *matCellDef="let row">{{ row.company.webSite }}</td>
      </ng-container>
      <ng-container matColumnDef="active">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Activation</th>
        <td mat-cell *matCellDef="let row">{{ row.company.active ? 'Activé' : 'Désactivé' }}</td>
      </ng-container>
      <ng-container matColumnDef="siret">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Siret</th>
        <td mat-cell *matCellDef="let row" class="mobile-inline mobile-separator">{{ row.company.siret }}</td>
      </ng-container>
      <ng-container matColumnDef="vatNumber">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>N° TVA</th>
        <td mat-cell *matCellDef="let row">{{ row.company.vatNumber }}</td>
      </ng-container>
      <ng-container matColumnDef="dateCreate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date création</th>
        <td mat-cell *matCellDef="let row">{{ row.company.dateCreate | dateTimeFormat }}</td>
      </ng-container>
      <ng-container matColumnDef="uid">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>ID</th>
        <td mat-cell *matCellDef="let row">{{ row.uid }}</td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button [matMenuTriggerFor]="actions" [matMenuTriggerData]="{data:row}">
            <mat-icon>more_vert</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator [pageSize]="paging.pagingPageSize" [pageSizeOptions]="paging.pagingPageSizeOptions"
      showFirstLastButtons></mat-paginator>
  </div>
</div>

<mat-menu #actions="matMenu">
  <ng-template matMenuContent let-row="data">
    <ul class="menu-actions">
      <li *ngIf="row.company.active">
        <a (click)="confirmDeActivate(row.company)"><mat-icon color="primary">block</mat-icon><span
            class="text">Désactiver le
            partenaire</span></a>
      </li>
      <li *ngIf="!row.company.active">
        <a (click)="confirmActivate(row.company)"><mat-icon color="primary">check</mat-icon><span class="text">Activer
            le
            partenaire</span></a>
      </li>
      <li>
        <a (click)="edit(row.company)"><mat-icon color="primary">create</mat-icon><span class="text">Modifier le
            partenaire</span></a>
      </li>
      <li>
        <a (click)="settings(row.company)"><mat-icon color="primary">settings</mat-icon><span class="text">Paramétrer le
            partenaire</span></a>
      </li>
      <li>
        <a (click)="confirmDelete(row.company)">
          <mat-icon color="primary">delete_forever</mat-icon>
          <span class="text">Supprimer le partenaire</span>
        </a>
      </li>
    </ul>
  </ng-template>
</mat-menu>
